import React from 'react';
import { View } from 'react-native';
import type { SvgProps } from 'react-native-svg';
import { Text } from '~/components';

interface Props {
  icon: React.FC<SvgProps>;
  description: string;
}

const Benefit: React.FC<Props> = ({ icon: Icon, description }) => {
  return (
    <View className="mb-8 items-center justify-center sm:flex-[0.3]">
      <Icon width={64} height={64} />
      <Text className="text-center text-base mt-2 text-gray-500">
        {description}
      </Text>
    </View>
  );
};

export default Benefit;
